/**
 * @file video.js
 */
'use strict';

exports.__esModule = true;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _globalWindow = require('global/window');

var _globalWindow2 = _interopRequireDefault(_globalWindow);

var _globalDocument = require('global/document');

var _globalDocument2 = _interopRequireDefault(_globalDocument);

var _setup = require('./setup');

var setup = _interopRequireWildcard(_setup);

var _utilsStylesheetJs = require('./utils/stylesheet.js');

var stylesheet = _interopRequireWildcard(_utilsStylesheetJs);

var _component = require('./component');

var _component2 = _interopRequireDefault(_component);

var _eventTarget = require('./event-target');

var _eventTarget2 = _interopRequireDefault(_eventTarget);

var _utilsEventsJs = require('./utils/events.js');

var Events = _interopRequireWildcard(_utilsEventsJs);

var _player = require('./player');

var _player2 = _interopRequireDefault(_player);

var _pluginsJs = require('./plugins.js');

var _pluginsJs2 = _interopRequireDefault(_pluginsJs);

var _srcJsUtilsMergeOptionsJs = require('../../src/js/utils/merge-options.js');

var _srcJsUtilsMergeOptionsJs2 = _interopRequireDefault(_srcJsUtilsMergeOptionsJs);

var _utilsFnJs = require('./utils/fn.js');

var Fn = _interopRequireWildcard(_utilsFnJs);

var _tracksTextTrackJs = require('./tracks/text-track.js');

var _tracksTextTrackJs2 = _interopRequireDefault(_tracksTextTrackJs);

var _tracksAudioTrackJs = require('./tracks/audio-track.js');

var _tracksAudioTrackJs2 = _interopRequireDefault(_tracksAudioTrackJs);

var _tracksVideoTrackJs = require('./tracks/video-track.js');

var _tracksVideoTrackJs2 = _interopRequireDefault(_tracksVideoTrackJs);

var _objectAssign = require('object.assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _utilsTimeRangesJs = require('./utils/time-ranges.js');

var _utilsFormatTimeJs = require('./utils/format-time.js');

var _utilsFormatTimeJs2 = _interopRequireDefault(_utilsFormatTimeJs);

var _utilsLogJs = require('./utils/log.js');

var _utilsLogJs2 = _interopRequireDefault(_utilsLogJs);

var _utilsDomJs = require('./utils/dom.js');

var Dom = _interopRequireWildcard(_utilsDomJs);

var _utilsBrowserJs = require('./utils/browser.js');

var browser = _interopRequireWildcard(_utilsBrowserJs);

var _utilsUrlJs = require('./utils/url.js');

var Url = _interopRequireWildcard(_utilsUrlJs);

var _extendJs = require('./extend.js');

var _extendJs2 = _interopRequireDefault(_extendJs);

var _lodashCompatObjectMerge = require('lodash-compat/object/merge');

var _lodashCompatObjectMerge2 = _interopRequireDefault(_lodashCompatObjectMerge);

var _utilsCreateDeprecationProxyJs = require('./utils/create-deprecation-proxy.js');

var _utilsCreateDeprecationProxyJs2 = _interopRequireDefault(_utilsCreateDeprecationProxyJs);

var _xhr = require('xhr');

var _xhr2 = _interopRequireDefault(_xhr);

// Include the built-in techs

var _techTechJs = require('./tech/tech.js');

var _techTechJs2 = _interopRequireDefault(_techTechJs);

var _techHtml5Js = require('./tech/html5.js');

var _techHtml5Js2 = _interopRequireDefault(_techHtml5Js);

var _techFlashJs = require('./tech/flash.js');

var _techFlashJs2 = _interopRequireDefault(_techFlashJs);

// HTML5 Element Shim for IE8
if (typeof HTMLVideoElement === 'undefined') {
  _globalDocument2['default'].createElement('video');
  _globalDocument2['default'].createElement('audio');
  _globalDocument2['default'].createElement('track');
}

/**
 * Doubles as the main function for users to create a player instance and also
 * the main library object.
 * The `videojs` function can be used to initialize or retrieve a player.
 * ```js
 *     var myPlayer = videojs('my_video_id');
 * ```
 *
 * @param  {String|Element} id      Video element or video element ID
 * @param  {Object=} options        Optional options object for config/settings
 * @param  {Function=} ready        Optional ready callback
 * @return {Player}                 A player instance
 * @mixes videojs
 * @method videojs
 */
var videojs = function videojs(id, options, ready) {
  var tag = undefined; // Element of ID

  // Allow for element or ID to be passed in
  // String ID
  if (typeof id === 'string') {

    // Adjust for jQuery ID syntax
    if (id.indexOf('#') === 0) {
      id = id.slice(1);
    }

    // If a player instance has already been created for this ID return it.
    if (videojs.getPlayers()[id]) {

      // If options or ready funtion are passed, warn
      if (options) {
        _utilsLogJs2['default'].warn('Player "' + id + '" is already initialised. Options will not be applied.');
      }

      if (ready) {
        videojs.getPlayers()[id].ready(ready);
      }

      return videojs.getPlayers()[id];

      // Otherwise get element for ID
    } else {
        tag = Dom.getEl(id);
      }

    // ID is a media element
  } else {
      tag = id;
    }

  // Check for a useable element
  if (!tag || !tag.nodeName) {
    // re: nodeName, could be a box div also
    throw new TypeError('The element or ID supplied is not valid. (videojs)'); // Returns
  }

  // Element may have a player attr referring to an already created player instance.
  // If not, set up a new player and return the instance.
  return tag['player'] || _player2['default'].players[tag.playerId] || new _player2['default'](tag, options, ready);
};

// Add default styles
if (_globalWindow2['default'].VIDEOJS_NO_DYNAMIC_STYLE !== true) {
  var style = Dom.$('.vjs-styles-defaults');

  if (!style) {
    style = stylesheet.createStyleElement('vjs-styles-defaults');
    var head = Dom.$('head');
    head.insertBefore(style, head.firstChild);
    stylesheet.setTextContent(style, '\n      .video-js {\n        width: 300px;\n        height: 150px;\n      }\n\n      .vjs-fluid {\n        padding-top: 56.25%\n      }\n    ');
  }
}

// Run Auto-load players
// You have to wait at least once in case this script is loaded after your video in the DOM (weird behavior only with minified version)
setup.autoSetupTimeout(1, videojs);

/*
 * Current software version (semver)
 *
 * @type {String}
 */
videojs.VERSION = '5.10.2-27';

/**
 * Indicates it's the Hola version of video.js
 *
 * @type {boolean}
 */
videojs.HOLA_VERSION = true;

/**
 * The global options object. These are the settings that take effect
 * if no overrides are specified when the player is created.
 *
 * ```js
 *     videojs.options.autoplay = true
 *     // -> all players will autoplay by default
 * ```
 *
 * @type {Object}
 */
videojs.options = _player2['default'].prototype.options_;

/**
 * Get an object with the currently created players, keyed by player ID
 *
 * @return {Object} The created players
 * @mixes videojs
 * @method getPlayers
 */
videojs.getPlayers = function () {
  return _player2['default'].players;
};

/**
 * For backward compatibility, expose players object.
 *
 * @deprecated
 * @memberOf videojs
 * @property {Object|Proxy} players
 */
videojs.players = _utilsCreateDeprecationProxyJs2['default'](_player2['default'].players, {
  get: 'Access to videojs.players is deprecated; use videojs.getPlayers instead',
  set: 'Modification of videojs.players is deprecated'
});

/**
 * Get a component class object by name
 * ```js
 *     var VjsButton = videojs.getComponent('Button');
 *     // Create a new instance of the component
 *     var myButton = new VjsButton(myPlayer);
 * ```
 *
 * @return {Component} Component identified by name
 * @mixes videojs
 * @method getComponent
 */
videojs.getComponent = _component2['default'].getComponent;

/**
 * Register a component so it can referred to by name
 * Used when adding to other
 * components, either through addChild
 * `component.addChild('myComponent')`
 * or through default children options
 * `{ children: ['myComponent'] }`.
 * ```js
 *     // Get a component to subclass
 *     var VjsButton = videojs.getComponent('Button');
 *     // Subclass the component (see 'extend' doc for more info)
 *     var MySpecialButton = videojs.extend(VjsButton, {});
 *     // Register the new component
 *     VjsButton.registerComponent('MySepcialButton', MySepcialButton);
 *     // (optionally) add the new component as a default player child
 *     myPlayer.addChild('MySepcialButton');
 * ```
 * NOTE: You could also just initialize the component before adding.
 * `component.addChild(new MyComponent());`
 *
 * @param {String} The class name of the component
 * @param {Component} The component class
 * @return {Component} The newly registered component
 * @mixes videojs
 * @method registerComponent
 */
videojs.registerComponent = function (name, comp) {
  if (_techTechJs2['default'].isTech(comp)) {
    _utilsLogJs2['default'].warn('The ' + name + ' tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)');
  }

  _component2['default'].registerComponent.call(_component2['default'], name, comp);
};

/**
 * Get a Tech class object by name
 * ```js
 *     var Html5 = videojs.getTech('Html5');
 *     // Create a new instance of the component
 *     var html5 = new Html5(options);
 * ```
 *
 * @return {Tech} Tech identified by name
 * @mixes videojs
 * @method getComponent
 */
videojs.getTech = _techTechJs2['default'].getTech;

/**
 * Register a Tech so it can referred to by name.
 * This is used in the tech order for the player.
 *
 * ```js
 *     // get the Html5 Tech
 *     var Html5 = videojs.getTech('Html5');
 *     var MyTech = videojs.extend(Html5, {});
 *     // Register the new Tech
 *     VjsButton.registerTech('Tech', MyTech);
 *     var player = videojs('myplayer', {
 *       techOrder: ['myTech', 'html5']
 *     });
 * ```
 *
 * @param {String} The class name of the tech
 * @param {Tech} The tech class
 * @return {Tech} The newly registered Tech
 * @mixes videojs
 * @method registerTech
 */
videojs.registerTech = _techTechJs2['default'].registerTech;

/**
 * A suite of browser and device tests
 *
 * @type {Object}
 * @private
 */
videojs.browser = browser;

/**
 * Whether or not the browser supports touch events. Included for backward
 * compatibility with 4.x, but deprecated. Use `videojs.browser.TOUCH_ENABLED`
 * instead going forward.
 *
 * @deprecated
 * @type {Boolean}
 */
videojs.TOUCH_ENABLED = browser.TOUCH_ENABLED;

/**
 * Subclass an existing class
 * Mimics ES6 subclassing with the `extend` keyword
 * ```js
 *     // Create a basic javascript 'class'
 *     function MyClass(name){
 *       // Set a property at initialization
 *       this.myName = name;
 *     }
 *     // Create an instance method
 *     MyClass.prototype.sayMyName = function(){
 *       alert(this.myName);
 *     };
 *     // Subclass the exisitng class and change the name
 *     // when initializing
 *     var MySubClass = videojs.extend(MyClass, {
 *       constructor: function(name) {
 *         // Call the super class constructor for the subclass
 *         MyClass.call(this, name)
 *       }
 *     });
 *     // Create an instance of the new sub class
 *     var myInstance = new MySubClass('John');
 *     myInstance.sayMyName(); // -> should alert "John"
 * ```
 *
 * @param {Function} The Class to subclass
 * @param {Object} An object including instace methods for the new class
 *                   Optionally including a `constructor` function
 * @return {Function} The newly created subclass
 * @mixes videojs
 * @method extend
 */
videojs.extend = _extendJs2['default'];

/**
 * Merge two options objects recursively
 * Performs a deep merge like lodash.merge but **only merges plain objects**
 * (not arrays, elements, anything else)
 * Other values will be copied directly from the second object.
 * ```js
 *     var defaultOptions = {
 *       foo: true,
 *       bar: {
 *         a: true,
 *         b: [1,2,3]
 *       }
 *     };
 *     var newOptions = {
 *       foo: false,
 *       bar: {
 *         b: [4,5,6]
 *       }
 *     };
 *     var result = videojs.mergeOptions(defaultOptions, newOptions);
 *     // result.foo = false;
 *     // result.bar.a = true;
 *     // result.bar.b = [4,5,6];
 * ```
 *
 * @param {Object} defaults  The options object whose values will be overriden
 * @param {Object} overrides The options object with values to override the first
 * @param {Object} etc       Any number of additional options objects
 *
 * @return {Object} a new object with the merged values
 * @mixes videojs
 * @method mergeOptions
 */
videojs.mergeOptions = _srcJsUtilsMergeOptionsJs2['default'];

/**
 * Change the context (this) of a function
 *
 *     videojs.bind(newContext, function(){
 *       this === newContext
 *     });
 *
 * NOTE: as of v5.0 we require an ES5 shim, so you should use the native
 * `function(){}.bind(newContext);` instead of this.
 *
 * @param  {*}        context The object to bind as scope
 * @param  {Function} fn      The function to be bound to a scope
 * @param  {Number=}  uid     An optional unique ID for the function to be set
 * @return {Function}
 */
videojs.bind = Fn.bind;

/**
 * Create a Video.js player plugin
 * Plugins are only initialized when options for the plugin are included
 * in the player options, or the plugin function on the player instance is
 * called.
 * **See the plugin guide in the docs for a more detailed example**
 * ```js
 *     // Make a plugin that alerts when the player plays
 *     videojs.plugin('myPlugin', function(myPluginOptions) {
 *       myPluginOptions = myPluginOptions || {};
 *
 *       var player = this;
 *       var alertText = myPluginOptions.text || 'Player is playing!'
 *
 *       player.on('play', function(){
 *         alert(alertText);
 *       });
 *     });
 *     // USAGE EXAMPLES
 *     // EXAMPLE 1: New player with plugin options, call plugin immediately
 *     var player1 = videojs('idOne', {
 *       myPlugin: {
 *         text: 'Custom text!'
 *       }
 *     });
 *     // Click play
 *     // --> Should alert 'Custom text!'
 *     // EXAMPLE 3: New player, initialize plugin later
 *     var player3 = videojs('idThree');
 *     // Click play
 *     // --> NO ALERT
 *     // Click pause
 *     // Initialize plugin using the plugin function on the player instance
 *     player3.myPlugin({
 *       text: 'Plugin added later!'
 *     });
 *     // Click play
 *     // --> Should alert 'Plugin added later!'
 * ```
 *
 * @param {String} name The plugin name
 * @param {Function} fn The plugin function that will be called with options
 * @mixes videojs
 * @method plugin
 */
videojs.plugin = _pluginsJs2['default'];

/**
 * Adding languages so that they're available to all players.
 * ```js
 *     videojs.addLanguage('es', { 'Hello': 'Hola' });
 * ```
 *
 * @param  {String} code The language code or dictionary property
 * @param  {Object} data The data values to be translated
 * @return {Object} The resulting language dictionary object
 * @mixes videojs
 * @method addLanguage
 */
videojs.addLanguage = function (code, data) {
  var _merge;

  code = ('' + code).toLowerCase();
  return _lodashCompatObjectMerge2['default'](videojs.options.languages, (_merge = {}, _merge[code] = data, _merge))[code];
};

/**
 * Log debug messages.
 *
 * @param {...Object} messages One or more messages to log
 */
videojs.log = _utilsLogJs2['default'];

/**
 * Creates an emulated TimeRange object.
 *
 * @param  {Number|Array} start Start time in seconds or an array of ranges
 * @param  {Number} end   End time in seconds
 * @return {Object}       Fake TimeRange object
 * @method createTimeRange
 */
videojs.createTimeRange = videojs.createTimeRanges = _utilsTimeRangesJs.createTimeRanges;

/**
 * Format seconds as a time string, H:MM:SS or M:SS
 * Supplying a guide (in seconds) will force a number of leading zeros
 * to cover the length of the guide
 *
 * @param  {Number} seconds Number of seconds to be turned into a string
 * @param  {Number} guide   Number (in seconds) to model the string after
 * @return {String}         Time formatted as H:MM:SS or M:SS
 * @method formatTime
 */
videojs.formatTime = _utilsFormatTimeJs2['default'];

/**
 * Resolve and parse the elements of a URL
 *
 * @param  {String} url The url to parse
 * @return {Object}     An object of url details
 * @method parseUrl
 */
videojs.parseUrl = Url.parseUrl;

/**
 * Returns whether the url passed is a cross domain request or not.
 *
 * @param {String} url The url to check
 * @return {Boolean}   Whether it is a cross domain request or not
 * @method isCrossOrigin
 */
videojs.isCrossOrigin = Url.isCrossOrigin;

/**
 * Event target class.
 *
 * @type {Function}
 */
videojs.EventTarget = _eventTarget2['default'];

/**
 * Add an event listener to element
 * It stores the handler function in a separate cache object
 * and adds a generic handler to the element's event,
 * along with a unique id (guid) to the element.
 *
 * @param  {Element|Object}   elem Element or object to bind listeners to
 * @param  {String|Array}   type Type of event to bind to.
 * @param  {Function} fn   Event listener.
 * @method on
 */
videojs.on = Events.on;

/**
 * Trigger a listener only once for an event
 *
 * @param  {Element|Object}   elem Element or object to
 * @param  {String|Array}   type Name/type of event
 * @param  {Function} fn Event handler function
 * @method one
 */
videojs.one = Events.one;

/**
 * Removes event listeners from an element
 *
 * @param  {Element|Object}   elem Object to remove listeners from
 * @param  {String|Array=}   type Type of listener to remove. Don't include to remove all events from element.
 * @param  {Function} fn   Specific listener to remove. Don't include to remove listeners for an event type.
 * @method off
 */
videojs.off = Events.off;

/**
 * Trigger an event for an element
 *
 * @param  {Element|Object}      elem  Element to trigger an event on
 * @param  {Event|Object|String} event A string (the type) or an event object with a type attribute
 * @param  {Object} [hash] data hash to pass along with the event
 * @return {Boolean=} Returned only if default was prevented
 * @method trigger
 */
videojs.trigger = Events.trigger;

/**
 * A cross-browser XMLHttpRequest wrapper. Here's a simple example:
 *
 *     videojs.xhr({
 *       body: someJSONString,
 *       uri: "/foo",
 *       headers: {
 *         "Content-Type": "application/json"
 *       }
 *     }, function (err, resp, body) {
 *       // check resp.statusCode
 *     });
 *
 * Check out the [full
 * documentation](https://github.com/Raynos/xhr/blob/v2.1.0/README.md)
 * for more options.
 *
 * @param {Object} options settings for the request.
 * @return {XMLHttpRequest|XDomainRequest} the request object.
 * @see https://github.com/Raynos/xhr
 */
videojs.xhr = _xhr2['default'];

/**
 * TextTrack class
 *
 * @type {Function}
 */
videojs.TextTrack = _tracksTextTrackJs2['default'];

/**
 * export the AudioTrack class so that source handlers can create
 * AudioTracks and then add them to the players AudioTrackList
 *
 * @type {Function}
 */
videojs.AudioTrack = _tracksAudioTrackJs2['default'];

/**
 * export the VideoTrack class so that source handlers can create
 * VideoTracks and then add them to the players VideoTrackList
 *
 * @type {Function}
 */
videojs.VideoTrack = _tracksVideoTrackJs2['default'];

/**
 * Determines, via duck typing, whether or not a value is a DOM element.
 *
 * @method isEl
 * @param  {Mixed} value
 * @return {Boolean}
 */
videojs.isEl = Dom.isEl;

/**
 * Determines, via duck typing, whether or not a value is a text node.
 *
 * @method isTextNode
 * @param  {Mixed} value
 * @return {Boolean}
 */
videojs.isTextNode = Dom.isTextNode;

/**
 * Creates an element and applies properties.
 *
 * @method createEl
 * @param  {String} [tagName='div'] Name of tag to be created.
 * @param  {Object} [properties={}] Element properties to be applied.
 * @param  {Object} [attributes={}] Element attributes to be applied.
 * @return {Element}
 */
videojs.createEl = Dom.createEl;

/**
 * Check if an element has a CSS class
 *
 * @method hasClass
 * @param {Element} element Element to check
 * @param {String} classToCheck Classname to check
 */
videojs.hasClass = Dom.hasElClass;

/**
 * Add a CSS class name to an element
 *
 * @method addClass
 * @param {Element} element    Element to add class name to
 * @param {String} classToAdd Classname to add
 */
videojs.addClass = Dom.addElClass;

/**
 * Remove a CSS class name from an element
 *
 * @method removeClass
 * @param {Element} element    Element to remove from class name
 * @param {String} classToRemove Classname to remove
 */
videojs.removeClass = Dom.removeElClass;

/**
 * Adds or removes a CSS class name on an element depending on an optional
 * condition or the presence/absence of the class name.
 *
 * @method toggleElClass
 * @param  {Element} element
 * @param  {String} classToToggle
 * @param  {Boolean|Function} [predicate]
 *         Can be a function that returns a Boolean. If `true`, the class
 *         will be added; if `false`, the class will be removed. If not
 *         given, the class will be added if not present and vice versa.
 */
videojs.toggleClass = Dom.toggleElClass;

/**
 * Apply attributes to an HTML element.
 *
 * @method setAttributes
 * @param  {Element} el         Target element.
 * @param  {Object=} attributes Element attributes to be applied.
 */
videojs.setAttributes = Dom.setElAttributes;

/**
 * Get an element's attribute values, as defined on the HTML tag
 * Attributes are not the same as properties. They're defined on the tag
 * or with setAttribute (which shouldn't be used with HTML)
 * This will return true or false for boolean attributes.
 *
 * @method getAttributes
 * @param  {Element} tag Element from which to get tag attributes
 * @return {Object}
 */
videojs.getAttributes = Dom.getElAttributes;

/**
 * Empties the contents of an element.
 *
 * @method emptyEl
 * @param  {Element} el
 * @return {Element}
 */
videojs.emptyEl = Dom.emptyEl;

/**
 * Normalizes and appends content to an element.
 *
 * The content for an element can be passed in multiple types and
 * combinations, whose behavior is as follows:
 *
 * - String
 *   Normalized into a text node.
 *
 * - Element, TextNode
 *   Passed through.
 *
 * - Array
 *   A one-dimensional array of strings, elements, nodes, or functions (which
 *   return single strings, elements, or nodes).
 *
 * - Function
 *   If the sole argument, is expected to produce a string, element,
 *   node, or array.
 *
 * @method appendContent
 * @param  {Element} el
 * @param  {String|Element|TextNode|Array|Function} content
 * @return {Element}
 */
videojs.appendContent = Dom.appendContent;

/**
 * Normalizes and inserts content into an element; this is identical to
 * `appendContent()`, except it empties the element first.
 *
 * The content for an element can be passed in multiple types and
 * combinations, whose behavior is as follows:
 *
 * - String
 *   Normalized into a text node.
 *
 * - Element, TextNode
 *   Passed through.
 *
 * - Array
 *   A one-dimensional array of strings, elements, nodes, or functions (which
 *   return single strings, elements, or nodes).
 *
 * - Function
 *   If the sole argument, is expected to produce a string, element,
 *   node, or array.
 *
 * @method insertContent
 * @param  {Element} el
 * @param  {String|Element|TextNode|Array|Function} content
 * @return {Element}
 */
videojs.insertContent = Dom.insertContent;

/*
 * Custom Universal Module Definition (UMD)
 *
 * Video.js will never be a non-browser lib so we can simplify UMD a bunch and
 * still support requirejs and browserify. This also needs to be closure
 * compiler compatible, so string keys are used.
 */
if (typeof define === 'function' && define['amd']) {
  define('videojs', [], function () {
    return videojs;
  });

  // checking that module is an object too because of umdjs/umd#35
} else if (typeof exports === 'object' && typeof module === 'object') {
    module['exports'] = videojs;
  }

exports['default'] = videojs;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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